import React,{useEffect, useState} from 'react';
import style from "./settings.module.css";
import emptyIcon from "../../assets/images/emptyAutomated.svg";
import deactivateImg from "../../assets/images/deactivateImg.svg";
import nigeria_icon from '../../assets/images/nigeria.svg'
import ghana_icon from '../../assets/images/ghanaflag.svg'
import spin_circle from '../../assets/images/Loader anim.png'
import successIcon from '../../assets/images/success-icon.svg'
import Modal from '../modal/Modal';
import { useSelector, useDispatch } from 'react-redux';
import { disableAutomatedPayment, enableAutomatedPayment, getAutomatedPayments, getBanksByWalletId, enableFiatAutomatedPayment, disableFiatAutomatedPayment } from '../../store/settings/settingsActions';
import Lottie from "lottie-react";
import loader from "../../assets/lottie/loader.json";


const AutomatedPaymentPage = ({setNewRoute}) => {

    const dispatch = useDispatch()
    
    // ========== STATES ==========
    const [paymentType, setPaymentType] = useState("bank"); // "bank" or "fiat"
    const [isDepositModal, setDepositModal] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isSuccessModal, setSuccessModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [location, setLocation] = useState("NGN");
    const [type, setType] = useState("enabled");
    const [selectedBankId, setSelectedBankId] = useState(null);

    // ========== REDUX SELECTORS ==========
    const allAccounts = useSelector((state) => state.settings.allAccounts);
    const automated_payment_enabled = useSelector((state) => state.settings.automated_payment_enabled);
    const fiat_automated_payment = useSelector((state) => state.settings.fiat_automated_payment);
    const default_bank_account = useSelector((state) => state.settings.default_bank_account);
    const walletData = useSelector((state) => state.wallet.data);

    // ========== CONSTANTS ==========
    const currencyIcons = {
        NGN: nigeria_icon,
        GHS: ghana_icon,
    };

    // ========== BANK PAYMENT HANDLERS ==========
    const handleSelectBank = (id) => {
        setSelectedBankId(id);
    };

    const handleChangeAccount = (id) => {
        setSelectedBankId(id)
        setType("change")
        setDepositModal(true)
    }

    const handleActivateBank = () => {
        setDepositModal(false)
        setIsOpen(true)
        let fiatWalletId = walletData.fiatWallets.find((item) => item.Currency.code === location).id
        dispatch(enableAutomatedPayment({
            bankAccountId: selectedBankId,
            walletId: fiatWalletId
        })).then((res) => {
            if(res?.type === "enableAutomatedPayment/fulfilled"){
                setIsOpen(false)
                setSuccessModal(true)
                dispatch(getAutomatedPayments({
                    walletId: fiatWalletId
                }))
            }
            else if(res?.type === "enableAutomatedPayment/rejected"){
                setIsOpen(false)
            }
        })
    }

    const handleDeactivateBank = () => {
        setType("disabled")
        setDepositModal(false)
        setIsOpen(true)
        let fiatWalletId = walletData.fiatWallets.find((item) => item.Currency.code === location).id
        dispatch(disableAutomatedPayment({
            walletId: fiatWalletId
        })).then((res) => {
            if(res?.type === "disableAutomatedPayment/fulfilled"){
                setIsOpen(false)
                setSuccessModal(true)
                dispatch(getAutomatedPayments({
                    walletId: fiatWalletId
                }))
            }
            else if(res?.type === "disableAutomatedPayment/rejected"){
                setIsOpen(false)
            }
        })
    }

    // ========== FIAT PAYMENT HANDLERS ==========
    const handleEnableFiatPayment = () => {
        setIsOpen(true)
        let fiatWalletId = walletData.fiatWallets.find((item) => item.Currency.code === location).id
        dispatch(enableFiatAutomatedPayment({
            walletId: fiatWalletId
        })).then((res) => {
            if(res?.type === "enableFiatAutomatedPayment/fulfilled"){
                setIsOpen(false)
                setSuccessModal(true)
                setType("enabled")
                dispatch(getAutomatedPayments({
                    walletId: fiatWalletId
                }))
            }
            else if(res?.type === "enableFiatAutomatedPayment/rejected"){
                setIsOpen(false)
            }
        })
    }

    const handleDisableFiatPayment = () => {
        setIsOpen(true)
        setType("disabled")
        let fiatWalletId = walletData.fiatWallets.find((item) => item.Currency.code === location).id
        dispatch(disableFiatAutomatedPayment({
            walletId: fiatWalletId
        })).then((res) => {
            if(res?.type === "disableFiatAutomatedPayment/fulfilled"){
                setIsOpen(false)
                setSuccessModal(true)
                dispatch(getAutomatedPayments({
                    walletId: fiatWalletId
                }))
            }
            else if(res?.type === "disableFiatAutomatedPayment/rejected"){
                setIsOpen(false)
            }
        })
    }

    // ========== EFFECTS ==========
    useEffect(() => {
        if (!walletData?.fiatWallets || walletData.fiatWallets.length === 0) return;

        let fiatWalletId = walletData.fiatWallets.find((item) => item.Currency.code === location).id
        let currencyId = walletData.fiatWallets.find((item) => item.Currency.code === location).Currency.id
        
        setLoading(true)
        
        // Get bank accounts for bank payment type
        if (paymentType === "bank") {
            dispatch(getBanksByWalletId({ currencyId }))
        }

        // Get automated payment status for both types
        dispatch(getAutomatedPayments({
            walletId: fiatWalletId
        })).then((res) => {
            if(res?.type === "getAutomatedPayments/fulfilled"){
                setLoading(false)
            }
            else if(res?.type === "getAutomatedPayments/rejected"){
                setLoading(false)
            }
        })
    }, [dispatch, location, walletData, paymentType])

    return ( 
        <>
            {/* ========= SELECT DEPOSIT BANK MODAL */}
            <Modal
                canClose={true}
                modalOpen={isDepositModal}
                setModalOpen={setDepositModal}
                title={`${type === "change" ? "Change Deposit Account" : "Select Deposit Account"}`}
                minWidth='35%'
            >
                {
                    allAccounts.bankAccounts && allAccounts.bankAccounts.length === 0
                    ?
                    (
                        <div style={{marginTop: '30px'}}>
                            <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                                You haven't added any bank accounts, would you like to add one?
                            </p>
                        </div>
                    )
                    :
                    ( 
                        allAccounts.bankAccounts && allAccounts.bankAccounts.length > 0 && allAccounts.bankAccounts.map((bank, index) => (
                            <div
                                key={bank.id}
                                onClick={() => handleSelectBank(bank.id)}
                                style={{ marginTop: index === 0 ? "30px" : "10px", cursor: 'pointer' }}
                                className={`${style.depositBankCard} ${selectedBankId === bank.id ? `${style.active}` : ""}`}
                            >
                                <h6 className={style.accountName}>
                                    {bank.details.bank_name ? (
                                        bank.details.bank_name
                                    ) : (
                                        <>
                                            {bank.details.bankName
                                                ? bank.details.bankName
                                                : bank.type.name}
                                        </>
                                    )}
                                </h6>
                                <h6 className={style.accountNumber}>{bank.account_number}</h6>
                                <h6 className={style.bankName}>{bank.details.account_name}</h6>
                            </div>
                        ))
                    )
                }
        
                <div style={{marginTop: '40px'}}>
                    {
                        allAccounts.bankAccounts && allAccounts.bankAccounts.length === 0
                        ? 
                        <button className={style.save} onClick={() => setNewRoute("bank")}>
                            Add Bank Account
                        </button>   
                        :
                        <>
                            <p onClick={() => setNewRoute("bank")} style={{textAlign: 'center', color:'#40196D', fontSize: 14, marginBottom: 0, cursor: 'pointer'}}>Add New Deposit Account</p>
                            <button style={{marginTop: '15px'}} onClick={handleActivateBank} disabled={selectedBankId === null || isOpen}  className={style.save}>
                                {type === "change" ? "Change" : "Enable"}
                            </button>
                        </>
                    }
                </div>
            </Modal>

            {/* ===== LOADING MODAL */}
            <Modal
                canClose={false}
                modalOpen={isOpen}
                setModalOpen={setIsOpen}
            >
                <div>
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                        <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
                    </div>

                    <div>
                        <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>
                            {type === "enabled" ? "Activating" : type === "disabled" ? "Deactivating" : "Changing"} Automated Payment
                        </h4>
                        <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                            Please wait...
                        </p>
                    </div>
                </div>
            </Modal>

            {/* ===== SUCCESS MODAL */}
            <Modal
                canClose={true}
                modalOpen={isSuccessModal}
                setModalOpen={setSuccessModal}
            >
                <div>
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                        <img src={ type === "enabled" ? successIcon : deactivateImg} alt="success icon" />
                    </div>

                    <div>
                        <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>
                            Automated Payment {type === "enabled" ? "Activated" : type === "disabled" ? "Deactivated" : "Changed"}
                        </h4>
                        <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                            {
                                type === "enabled"
                                ?
                                paymentType === "bank" 
                                    ? "You can now receive payments directly in your specified bank account"
                                    : "You can now receive fiat payments directly"
                                :
                                type === "disabled" 
                                ? 
                                paymentType === "bank"
                                    ? "You can no longer receive payments directly in your specified bank account"
                                    : "You can no longer receive fiat payments directly"
                                :
                                paymentType === "bank"
                                    ? "You can now receive payments directly in your specified bank account"
                                    : "You can now receive fiat payments directly"
                            }
                        </p>
                    </div>

                    <button onClick={() => setSuccessModal(false)} style={{marginTop: '20px'}} className={style.save}>
                        Continue
                    </button>
                </div>
            </Modal>

            {/* ===== MAIN PAGE CONTENT */}
            <div className={style.header}>

                {/* ===== PAYMENT TYPE TABS */}
                <div className={style.paymentTypeTabs} style={{marginBottom: '30px', borderBottom: '1px solid #90909042'}}>
                    <button
                        onClick={() => setPaymentType("bank")}
                        style={{
                            padding: '12px 20px',
                            border: 'none',
                            background: 'none',
                            fontSize: '16px',
                            fontWeight: '500',
                            color: paymentType === "bank" ? '#40196D' : '#B6B6B6',
                            borderBottom: paymentType === "bank" ? '3px solid #40196D' : 'none',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        Automated Bank Payment
                    </button>
                    <button
                        onClick={() => setPaymentType("fiat")}
                        style={{
                            padding: '12px 20px',
                            border: 'none',
                            background: 'none',
                            fontSize: '16px',
                            fontWeight: '500',
                            color: paymentType === "fiat" ? '#40196D' : '#B6B6B6',
                            borderBottom: paymentType === "fiat" ? '3px solid #40196D' : 'none',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        Automated Fiat Payment
                    </button>
                </div>

                {/* ===== CURRENCY TABS */}
                <div className={style.cashTabs}>
                    <ul>
                        {walletData?.fiatWallets
                            ?.filter(wallet => wallet.Currency.code !== "USD")
                            .map(wallet => {
                                const code = wallet.Currency.code;
                                const icon = currencyIcons[code];
                                const isSelected = location === code;

                                return (
                                    <li
                                        key={wallet.id}
                                        onClick={() => setLocation(code)}
                                        style={{
                                            borderBottom: isSelected
                                            ? "3px #40196D solid"
                                            : "0px #90909039 solid",
                                        }}
                                    >
                                        <div>
                                            <img
                                                src={icon}
                                                alt={`${code.toLowerCase()} icon`}
                                                style={{
                                                    width: "22px",
                                                    height: "22px",
                                                    borderRadius: "50%",
                                                    opacity: isSelected ? "100%" : "60%",
                                                }}
                                            />
                                            <p
                                                style={{
                                                    color: isSelected ? "#40196D" : "#C1C1C1",
                                                }}
                                            >
                                                {code} WALLET
                                            </p>
                                        </div>
                                    </li>
                                );
                            })}
                    </ul>
                </div>

                {/* ===== BANK AUTOMATED PAYMENT SECTION */}
                {paymentType === "bank" && (
                    <>
                        {
                            loading
                            ?
                            <div style={{marginTop: '40px'}} className={style.lottieWrap}>
                                <Lottie
                                    style={{
                                        width: "70px",
                                        height: "70px",
                                        color: "#fff",
                                        padding: "0px",
                                        margin: "0px",
                                    }}
                                    animationData={loader}
                                    loop={true}
                                />
                            </div>
                            :
                            default_bank_account === null 
                            ?
                            <div className={style.emptyDiv}>
                                <div>
                                    <img src={emptyIcon} alt="empty automated payments icon" />

                                    <div style={{marginTop:'30px'}}>
                                        <p>Bank automated payments enable you to receive funds directly into your preferred bank account.</p>
                                    </div>
                                </div>

                                <div style={{marginTop: '50px'}}>
                                    <button 
                                        onClick={() => {
                                            setDepositModal(true);
                                            setType("enabled")
                                        }}
                                    >
                                        Enable Bank Payment for {location} Wallet
                                    </button>
                                </div>
                            </div>
                            :
                            <div style={{marginTop: '30px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between',  minHeight: '500px'}}>
                                <div className={`${style.depositBankCard} ${automated_payment_enabled ? '' : style.disabled} `} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <div>
                                        <h6 className={style.accountName}>
                                            {default_bank_account ? default_bank_account.details.account_name: ''}
                                        </h6>
                                        <h6 className={style.accountNumber}>{default_bank_account ? default_bank_account.account_number: ''}</h6>
                                        <h6 className={style.bankName}>
                                            {default_bank_account ? default_bank_account.details.bank_name: ''}
                                        </h6>
                                    </div>

                                    {  
                                        automated_payment_enabled
                                        ?
                                        <div 
                                            onClick={() =>handleChangeAccount(default_bank_account.id)}
                                            style={{background: '#ECE8F0', borderRadius: '20px', padding: '10px 20px'}}>
                                            <p style={{color: '#40196D', fontWeight: '400', fontSize: 14}}>Change Account</p>
                                        </div>
                                        : 
                                        null
                                    }
                                </div>

                                {
                                    automated_payment_enabled
                                    ?
                                    <div>
                                        <button onClick={handleDeactivateBank} className={style.deactivateBtn}>
                                            Disable Bank Payment
                                        </button>
                                    </div>
                                    : 
                                    <div>
                                        <p style={{textAlign: 'center', color:'#40196D', fontSize: 12, marginBottom: 5,}}>{location} Wallet bank payment disabled</p>
                                        <button
                                            onClick={() => {
                                                setDepositModal(true);
                                                setType("enabled")
                                            }}
                                            className={style.save}>
                                            Enable Bank Payment
                                        </button>
                                    </div>
                                }
                            </div>
                        }
                    </>
                )}

                {/* ===== FIAT AUTOMATED PAYMENT SECTION */}
                {paymentType === "fiat" && (
                    <>
                        {
                            loading
                            ?
                            <div style={{marginTop: '40px'}} className={style.lottieWrap}>
                                <Lottie
                                    style={{
                                        width: "70px",
                                        height: "70px",
                                        color: "#fff",
                                        padding: "0px",
                                        margin: "0px",
                                    }}
                                    animationData={loader}
                                    loop={true}
                                />
                            </div>
                            :
                            <div style={{marginTop: '30px', minHeight: '500px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                                <div>
                                    <div className={style.depositBankCard} style={{padding: '30px', textAlign: 'center'}}>
                                        <h6 className={style.accountName} style={{fontSize: '18px', marginBottom: '10px'}}>
                                            {location} Fiat Automated Payment
                                        </h6>
                                        <p style={{color: '#B6B6B6', fontSize: '14px', marginBottom: '0px'}}>
                                            {fiat_automated_payment 
                                                ? "Fiat automated payments are currently enabled for this wallet"
                                                : "Enable fiat automated payments to receive payments directly"
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div>
                                    {
                                        fiat_automated_payment
                                        ?
                                        <button onClick={handleDisableFiatPayment} className={style.deactivateBtn}>
                                            Disable Fiat Payment
                                        </button>
                                        :
                                        <button 
                                            onClick={handleEnableFiatPayment}
                                            className={style.save}>
                                            Enable Fiat Payment for {location} Wallet
                                        </button>
                                    }
                                </div>
                            </div>
                        }
                    </>
                )}
            </div>
        </>
    );
}
 
export default AutomatedPaymentPage;